import React from 'react';
import { Box, Skeleton } from '@mui/material';

const LoginSkeleton = () => (
  <Box sx={{ width: '100%', maxWidth: 420 }} aria-busy>
    {/* logo skeleton removed; big picture skeleton is on the left */}
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <Skeleton variant="circular" width={40} height={40} sx={{ mb: 1 }} />
      <Skeleton variant="text" width="60%" height={32} sx={{ mb: 1 }} />
      <Skeleton variant="text" width="80%" height={22} sx={{ mb: 3 }} />
      <Skeleton variant="rounded" width="100%" height={48} sx={{ mb: 2, borderRadius: 1 }} />
      <Skeleton variant="rounded" width="100%" height={48} sx={{ mb: 2, borderRadius: 1 }} />
      <Skeleton variant="rounded" width="100%" height={42} sx={{ mb: 1.5, borderRadius: 1 }} />
      <Skeleton variant="text" width="50%" height={18} />
    </Box>
  </Box>
);

export default LoginSkeleton;
